import { render, staticRenderFns } from "./question-root-node-new.vue?vue&type=template&id=19da93b0&scoped=true&"
import script from "./question-root-node-new.vue?vue&type=script&lang=js&"
export * from "./question-root-node-new.vue?vue&type=script&lang=js&"
import style0 from "./question-root-node-new.vue?vue&type=style&index=0&id=19da93b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19da93b0",
  null
  
)

export default component.exports